// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty_state_EmptyState__24JEV","illustration":"empty_state_illustration__3XrVw","details":"empty_state_details__25LD1"};